import React from 'react';

import Button from 'CommonComponents/Button';
import IconButton from 'CommonComponents/IconButton';

import RecentreIcon from 'Assets/icons/circle-plus.svg';
import FileExportIcon from 'Assets/icons/file-export.svg';
import MinusIcon from 'Assets/icons/minus.svg';
import PlusIcon from 'Assets/icons/plus.svg';
import FitIcon from 'Assets/icons/retract-shrink.svg';

/**
 * OrganigramToolbar
 *
 * The org chart's only set of viewport controls, pinned inside the top-right of
 * the canvas. It replaces both the chart library's own built-in toolbar and the
 * separately-positioned Export button each organigram surface used to render.
 *
 * Props are all callbacks into the live chart instance, plus the current zoom
 * as a whole percentage. Clicking the percentage resets the chart to 100%.
 */
export default function OrganigramToolbar({ zoomPercentage, onZoomIn, onZoomOut, onFit, onRecentre, onResetZoom, onExport }) {
    return (
        <div className="tw-absolute tw-top-3 tw-end-3 tw-z-10 tw-flex tw-items-center tw-gap-x-1 tw-rounded-lg tw-border tw-border-charcoal-25 tw-bg-white tw-p-1 tw-shadow-primary">
            <IconButton ghost onClick={onZoomIn} title={$t('Zoom in')} aria-label={$t('Zoom in')}>
                <PlusIcon className="tw-w-3.5 tw-h-3.5" />
            </IconButton>
            <IconButton ghost onClick={onZoomOut} title={$t('Zoom out')} aria-label={$t('Zoom out')}>
                <MinusIcon className="tw-w-3.5 tw-h-3.5" />
            </IconButton>
            <IconButton ghost onClick={onFit} title={$t('Fit to screen')} aria-label={$t('Fit to screen')}>
                <FitIcon className="tw-w-3.5 tw-h-3.5" />
            </IconButton>
            <IconButton ghost onClick={onRecentre} title={$t('Re-centre')} aria-label={$t('Re-centre')}>
                <RecentreIcon className="tw-w-3.5 tw-h-3.5" />
            </IconButton>
            <button
                type="button"
                onClick={onResetZoom}
                title={$t('Reset zoom to 100%')}
                className="tw-h-8 tw-min-w-12 tw-border-0 tw-border-s tw-border-solid tw-border-grey tw-bg-transparent tw-px-2 tw-text-xs tw-text-charcoal-75 hover:tw-text-charcoal focus:tw-outline-none"
            >
                {zoomPercentage}%
            </button>
            <Button variant="primary" small onClick={onExport} className="!tw-px-4">
                <FileExportIcon className="tw-w-3 tw-h-3" />
                {$t('Export to PDF')}
            </Button>
        </div>
    );
}
